<template>
  <div class="content">
    <div class="table-page-search-wrapper search-bt" >
      <a-form layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="版本">
              <global-select
                @change="handleVersionChange"
                :value.sync="queryParams.version"
                selectType="selectSearch"
                requestApi="/scp/scpMpsPlans/listMpsPlanVersion"
                :selectItem="{ value: 'realValue', label: 'label' }"
              />
            </a-form-item>
          </a-col>
          <!-- <a-col :md="6" :sm="24">
            <a-form-item label="物料">
              <global-select
                :value.sync="queryParams.itemId"
                :dropdown-match-select-width="false"
                selectType="selectAssembleSearch"
                requestApi="/mes/mesDiscreteJobs/assemblyBox"
                :selectItem="{ value: 'selectedValue', label: 'bringOutDataOne' }"
                searchParam="itemCode" />
            </a-form-item>
          </a-col> -->
          <a-col :md="6" :sm="24">
            <a-form-item label="调出供应商">
              <global-select
                :focusGet="true"
                :value.sync="queryParams.supplierAbbreviationOut"
                selectType="select"
                :setParams="{ version: queryParams.version || undefined }"
                searchParam="vendorCode"
                requestApi="/scp/scpMpsPlans/outSupplierCombo"
                :selectItem="{ value: 'label', label: 'label' }"></global-select>
            </a-form-item>
          </a-col>

          <template>

            <a-col :md="6" :sm="24">
              <a-form-item label="调入供应商">
                <global-select
                  :focusGet="true"
                  :value.sync="queryParams.supplierAbbreviationIn"
                  selectType="select"
                  :setParams="{ version: queryParams.version || undefined }"
                  searchParam="vendorCode"
                  requestApi="/scp/scpMpsPlans/inSupplierCombo"
                  :selectItem="{ value: 'label', label: 'label' }"></global-select>
              </a-form-item>
            </a-col>
          </template>
          <template v-if="advanced">

            <a-col :md="6" :sm="24">
              <a-form-item label="调整期间">
                <!-- <a-select v-model="queryParams.demandDeliveryDate" allowClear>
                  <a-select-option v-for="(item) in stateOptions" :key="item.dictValue">{{ item.dictLabel }}</a-select-option>
                </a-select> -->
                <global-select
                  :focusGet="true"
                  :value.sync="queryParams.demandDeliveryDate"
                  selectType="selectMultiple"
                  searchParam="vendorCode"
                  requestApi="/scp/scpMpsPlans/planSheetPeriod"
                  :selectItem="{ value: 'label', label: 'label' }"></global-select>
              </a-form-item>
            </a-col>
          </template>
          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="工艺大类">
                <global-select
                  :value.sync="queryParams.category"
                  selectType="selectSearch"
                  requestApi="/system/lookup/data/likeList"
                  :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                  :setParams="{ lookupType: 'SCP_PRODUCT_BROAD_CATEGORY' }"
                  searchParam="lookupValue"
                  :dropdown-match-select-width="false"
                />
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="onSearch" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
              <a @click="toggleAdvanced" class="ml8">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <template>
      <a-tabs class="content-tabs" type="card">
        <a-tab-pane :force-render="true" key="1" tab="计划单调整-调出明细">
          <plan-adjustment-out ref="PlanAdjustmentOut" @handle-run-plan-finish="handleRunPlanFinish"></plan-adjustment-out>
        </a-tab-pane>
        <a-tab-pane :force-render="true" key="2" tab="计划单调整-调入明细">
          <plan-adjustment-in ref="PlanAdjustmentIn" @handle-run-plan-finish="handleRunPlanFinish"></plan-adjustment-in>
          <!-- <history-info-table ref="HistoryInfoTable" :id="queryParams.sopDfcBasicDataId"></history-info-table> -->
        </a-tab-pane>
      </a-tabs>
    </template>
  </div>
</template>

      <script>
      import { apiDelFcNewProductDetail } from '@/api/scp/new-product-forecast/new-product-forecast'
      import { generateLsTableResData } from '@/utils/util.js';
      import { apiFindPagePlanExecutionList } from '@/api/mps/basic-data/mps-plan-execution.js'
      import PlanAdjustmentOut from './components/PlanAdjustmentOut.vue';
      import PlanAdjustmentIn from './components/PlanAdjustmentIn.vue';
      export default {
        // eslint-disable-next-line
        name: 'Mps-plan-adjustment',
        components: {
          PlanAdjustmentOut,
          PlanAdjustmentIn
        },
        data () {
          return {
            listSideOpinions: [],
            orderStateOpinions: [],
            monthToDayTypeOpinions: [],
            productBroadCategoryOpinions: [],
            isLoading: false,
            tableList: [],
            businessUnitList: [], // 事业部
            isSetTitle: false,
            // 表格配置
            tableProps: {
              requestApi: generateLsTableResData(apiFindPagePlanExecutionList, true),
              pageCurrent: true
            },
            isEdit: false,
            currentId: "",
            // 控制搜索展开
            advanced: true,
            queryParamsCommit: {},
            stateOptions: [
              {
                dictLabel: '未发放',
                dictValue: '未发放'
              },
              {
                dictLabel: '已发放',
                dictValue: '已发放'
              }
            ],
            // 查询参数
            queryParams: {
              // 预测名称
               version: '',
               // 版本
               itemId: undefined,
               category: undefined,
               supplierAbbreviationOut: undefined,
               supplierAbbreviationIn: undefined,
               demandDeliveryDate: undefined
            },
            queryParamsSelect: {},
            // 表格多选
            selectedRowKeys: [],
            selectedRows: [],
            // 状态快码
            statusOptions: [
              {
                dictLabel: "有效",
                dictValue: "Y"
              },
              {
                dictLabel: "无效",
                dictValue: "N"
              }
            ],
            baseUomFlagOptions: [
              {
                dictLabel: "是",
                dictValue: "Y"
              },
              {
                dictLabel: "否",
                dictValue: "N"
              }
            ],
            columns: [],
            columnsServe: [],
            unitOfMeasureList: [],
            unitOfMeasureListNew: []
          }
        },
        created () {
          // this.queryParams.version = this.$route.query.mpsVersion
           this.columns = this.columnsNative;
          //  this.getLookupList('SCP_PRODUCT_BROAD_CATEGORY', 'productBroadCategoryOpinions')
          //  this.getLookupList('SCP_MRP_SUPPLY_TYPE', 'orderStateOpinions')
          //  this.getLookupList('MDM_ORG_SUPPLIER_CLASS', 'listSideOpinions')
           // this.queryParams.version = '3231279'
        },
        mounted () {
        // if (this.queryParams.version) {
        //     this.onSearch()
        //   }
        },
        activated() {
          if (this.$route.query.mpsVersion) {
            this.queryParams.version = this.$route.query.mpsVersion
          }
          if (this.$route.query.productBroadCategory) {
            this.queryParams.category = this.$route.query.productBroadCategory
          }
          if (this.queryParams.version) {
            this.onSearch()
          }
        },
        methods: {
          onSearch () {
            if (!this.queryParams.version) {
              this.$message.error('版本必须选择')
              return
            }
            if (this.$refs.PlanAdjustmentOut) {
              this.$refs.PlanAdjustmentOut.onSearch(this.queryParams)
            }
            if (this.$refs.PlanAdjustmentIn) {
              this.$refs.PlanAdjustmentIn.onSearch(this.queryParams)
            }
          },
                    /** 行选中 */
         selectedRowChange (selectedRowKeys, selectedRows) {
            this.selectedRowKeys = selectedRowKeys
            this.selectedRows = selectedRows
          },
          handleDelete (tableList, record) {
            const self = this
          this.$confirm({
            title: '警告',
            content: `真的要删除该项的数据项吗?`,
            okText: '删除',
            okType: 'danger',
            cancelText: '取消',
            onOk () {
              const ids = []
              self.columnsServe.forEach((column) => {
                console.log(column.indexKey)
                const id = record[column.indexKey].id
                ids.push(id)
              })
              apiDelFcNewProductDetail(record).then(response => {
                if (response.code === 200) {
                  self.$message.success('删除成功')
                  self.onSearch()
                } else {
                  self.$message.error(response.msg)
                }
              })
            }
          })
          },
          handleOperation (text, record) {
            this.$router.push({ path: `/mps-Inspection-requirements/inspectionAdjustment` })
          },
          handleNameChange (val, selectList) {
            const filteredItem = selectList.filter(item => item.realValue === val);
            this.queryParams.startMonth = filteredItem[0].bringOutDataOne
          },
          handleVersionChange (val, selectList) {
           if (val) {
             const filteredItem = selectList.filter(item => item.realValue === val);
             this.queryParams.versionDescription = filteredItem[0].bringOutDataOne
             this.versionCode = this.queryParams.versionCode;
             this.versionDescription = this.queryParams.versionDescription;
           }
          },
          getLookupList (type, arr) {
          const lookupQueryParams = {
            lookupType: type,
            current: 1,
            pageSize: 100
          }
          this.getLookupListData(lookupQueryParams).then().then(response => {
            this[arr] = response.rows
            if (type === 'SCP_MRP_SUPPLY_TYPE') {
              const filteredArray = response.rows.filter(function (obj) {
                  return obj.attribute2 === "Y";
                  });
                  this[arr] = filteredArray
          }
          if (type === 'MDM_ORG_SUPPLIER_CLASS') {
              const filteredArray = response.rows.filter(function (obj) {
                  return obj.attribute2 === "Y";
                  });
                  this[arr] = filteredArray
          }
          })
          },
          blur (record) {
            if (!record.conversionRate || Number(record.conversionRate) <= 0) {
              this.$message.warning('折换不能为空且需大于0')
            } else {
              record.conversionRateInverse = this.$countBackwards(Number(record.conversionRate))
            }
          },
          statusOnChange () {
            this.queryParams.ifStop = this.queryParams.ifStop === 'Y' ? 'N' : 'Y'
          },
          // 导入导出excel
          /** 导出按钮操作 */
          // 编辑-保存
          handleSave (record) {
          },

          /** 重置按钮操作 */
          resetQuery () {
            this.queryParams = {
              // 预测名称
              version: '',
               // 版本
               itemId: undefined,
               category: undefined,
               supplierAbbreviationOut: undefined,
               supplierAbbreviationIn: undefined,
               demandDeliveryDate: undefined
            }
            this.queryParamsSelect = {}

            this.onSearch()
          },
          // 搜索框展开、收起
          toggleAdvanced () {
            this.advanced = !this.advanced
          },
          handleRunPlanFinish () {
            this.$success({
              title: '调整完成，点击确定返回供应商产能负荷页面',
              onOk: () => {
                this.event.$emit("close-and-open-page", {
                  closePath: [ '/mps/mps-result/mps-plan-adjustment', '/mps/mps-result/supplier-capacity-load' ],
                  openPath: `/mps/mps-result/supplier-capacity-load?id=${this.queryParams.version || ''}`
                });
              }
            });
          }
        }
      }
      </script>

      <style scoped lang="less">
      .ml10{
        margin-left: 10px;
      }.content{
      display: flex;
      flex-direction: column;
      width: 100%;
      height: 100%;
      }.search-bt{
      background-color: white;
      padding: 8px;
      margin-bottom: 8px;
      }.content-tabs{
          background-color: white;
          width: 100%;
          flex:1;
          padding: 8px;
      }
      </style>
